/**
 * @author
 * David Rivera (jherax)
 * https://github.com/jherax
 */

import noop from './noop';

/**
 * @public
 * Checks if the provided argument is a function and returns it,
 * otherwise an empty function is returned.
 *
 * @param  {any} callback - function to test
 * @return {Function}
 */
export default function invoke(callback) {
  if (typeof callback !== 'function') return noop;
  return callback;
}
